module.exports = __webpack_public_path__ + "static/media/nd-bg09.85050093.jpg";